<template>
  <Card v-if="pending">
    <NamiLoading />
  </Card>
  <Card v-else-if="!computedProgresses.length">
    <NoResults :message="$t('site.org.id.slug.achievements.no_results')" />
  </Card>
  <div v-else-if="data" class="space-y-4">
    <AchievementProgressCard
      v-for="ach in computedProgresses"
      :progress="ach"
    />
  </div>
</template>

<script setup lang="ts">
import {
  Achievement,
  type AchievementProgressEntity,
  getMultipleRelationships,
  isAchievement,
  isExpanded,
  isUser,
  type OrganizationEntity,
} from "~/src/api";

const nuxtApp = useNuxtApp();
const authStore = nuxtApp.$auth();
const authUserId = computed(() => authStore?.user?.profile.sub);

const { org } = defineProps<{
  org: OrganizationEntity;
}>();

const { data, pending } = useAsyncData(async () => {
  return await Achievement.getOrganizationAchievementProgresses(org.id, {
    includes: ["badge", "achievement"],
    order: { awardedAt: "desc" },
    // showAwarded: false,
  });
});

const owner = org.relationships.find(isUser)?.id;
const members = getMultipleRelationships(org, "member").map((rel) => rel.id);

const filterHidden = (prog: AchievementProgressEntity) => {
  const ach = prog.relationships.find(isAchievement);
  if (!ach || !isExpanded(ach)) return false;

  if (
    authUserId.value &&
    members.includes(authUserId.value) &&
    prog.attributes.targetReached
  )
    return true;
  if (
    authUserId.value &&
    owner === authUserId.value &&
    prog.attributes.targetReached
  )
    return true;
  if (prog.attributes.progressValue === 0) return false;
  return !ach.attributes.isHidden;
};

const computedProgresses = computed(
  () => data.value?.data.filter(filterHidden) ?? [],
);
</script>
